<template>
    <playerList :type="'AC_report'"></playerList>
</template>

<script>
    import playerList from "@/components/newPlayerList";
    export default {
        name: "AC_report",
        components:{
            playerList
        }
    }
</script>
